module.exports = __webpack_public_path__ + "static/media/xuebi_types.7c81f49b.png";